<template>
  <div class="imagesUploadComponent">
    <div class="imagesUploadComponent_imgWrap" v-for="(image, key) in images" v-bind:key="image+key">
      <image-upload
        v-bind:image="image"
        v-on:input="(image) => setImage(image, key)"
        v-bind:input-name="`${inputName}`"
      >
      </image-upload>
      <div class="imagesUploadComponent_move">
        <span class="imagesUploadComponent_move_btn" v-on:click="move('left', key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"/></svg>
        </span>
        <span class="imagesUploadComponent_move_btn" v-on:click="move('right', key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"/></svg>
        </span>
      </div>
    </div>

    <label class="imagesUploadComponent_dragZone"
      v-on:dragover="dragover"
      v-on:dragleave="dragleave"
      v-on:drop="drop"
      v-bind:style="dragZoneStyle"
      v-bind:for="uniqueId"
    >
      ＋追加添付
      <div class="imagesUploadComponent_uploading" v-if="isUploading">
        <img class="imagesUploadComponent_uploading_img" src="/svg/oval.svg" alt="">
        <span class="imagesUploadComponent_uploading_txt">
          アップロード中
          <span class="">高画質な画像だと1~2分ほど<br>時間が掛かることがあります</span>
        </span>
      </div>
    </label>

    <input v-bind:id="uniqueId" class="imagesUploadComponent_file" type="file" v-on:change="multiUploadFile" ref="inputFile" multiple>

  </div>
</template>


<script>
export default {
  props:['initImages', 'initLimit', 'inputName', 'initStoreDir'],
  data(){
    return{
      uniqueId:"",
      images:this.initImages ?? [],
      dragZoneStyle:{},
      limit:this.initLimit ?? 5,
      isUploading:false,
      storeDir:this.initStoreDir ?? 'temp',
    }
  },
  methods:{
    setImage(image, key){
      if (!image) {
        this.images.splice(key, 1);
        return;
      }
      this.$set(this.images, key, image);
    },
    move(direction, key){
      let tmpImg = "";
      switch (direction) {
        case 'left':
          if (key == 0) {
            return;
          }
          tmpImg = this.images[key - 1];
          this.$set(this.images, key - 1, this.images[key]);
          this.$set(this.images, key, tmpImg);
          break;

        case 'right':
          if (key == this.images.length - 1) {
            return;
          }
          tmpImg = this.images[key + 1];
          this.$set(this.images, key + 1, this.images[key]);
          this.$set(this.images, key, tmpImg);
          break;

        default:
          break;
      }
    },
    dragover(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ff3399";
    },
    dragleave(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";
    },
    drop(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";

      var files = e.dataTransfer.files;
      this.multiUpload(files);
    },
    multiUploadFile(e){
      let files = e.target.files;

      /*------------------------- 枚数チェック -------------------------*/
      if (this.images.length + files.length > this.limit) {
        alert(`登録できる写真の枚数は${this.limit}枚以下です。\n ${this.limit}枚以下になるように選択してください。\n `);
        return;
      }
      this.multiUpload(files);
    },
    multiUpload(files){
      for (let file of files) {
        this.uploadMedia(file);
      }
    },
    uploadMedia(file){

      /*------------------------- 容量チェック -------------------------*/
      if (file.size >= 50000000) {
        alert('一度に選択できるファイル容量を超えています。\n ' + '50MB以下になるように選択してください。\n ');
        return;
      }

      /*------------------------- 拡張子チェック -------------------------*/
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
        alert('対応外の形式です。jpeg、png形式の画像のみアップロード可能です。');
      }

      // 画像送信
      let formData = new FormData();
      formData.append('file', file);
      formData.append('store_dir', this.storeDir);

      let config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      this.isUploading           = true;
      this.$refs.inputFile.type  = 'text';
      this.$refs.inputFile.value = null;
      this.$refs.inputFile.type  = 'file';

      axios
        .post("/api/media-upload", formData, config)
        .then((response) => {
          if(response.data.success == false){
            // 途中でエラーが出た場合は、前の画像に戻す
            alert("アップロード中にエラーが発生しました。時間を置いてもう一度お試しください。")
            return;
          }

          this.images.push(response.data['path']);
        })
        .catch((error) => {
          // 途中でエラーが出た場合は、前の画像に戻す
          alert("アップロード中にエラーが発生しました。時間を置いてもう一度お試しください。")
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
  },
  created() {
    this.uniqueId = "imageUpload_"+Math.random().toString(32).substring(2) // 'a6dpgjqlq8g' 等
  },
}
</script>
<style lang="scss">
.imagesUploadComponent{
  display: contents;
  &_dragZone{
    position: relative;
    aspect-ratio: 1/1;
    border-radius: 4px;
    border: 1px solid #000;
    display: grid;
    place-items: center;
  }
  &_file{
    display: none;
  }
  &_imgWrap{
    position: relative;
    aspect-ratio: 1/1;
  }
  &_move{
    position: absolute;
    display: flex;
    gap: 15px;
    top: 5px;
    right: 5px;
    &_btn{
      background: #ffffff;
      border: 1px solid #000;
      border-radius: 4px;
      padding: 3px;
      svg{
        width: 20px;
        height: 20px;
      }
    }
  }
  &_uploading{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: grid;
    place-content: center;
    justify-items: center;
    gap: 10px;
    background: #ffffff80;
    &_img{
      width: 50%;
      height: 505;
    }
    &_txt{
      display: grid;
      text-align: center;
      font-weight: bold;
      span{
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
}
</style>
